import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    // Ensure accordion starts closed
    this.element.classList.remove('active');
    this.contentTarget.style.maxHeight = '0';
    const icon = this.element.querySelector('.accordion-icon');
    if (icon) icon.style.transform = 'rotate(0)';

    // Auto-expand if this accordion has the hash ID from URL
    this.checkForHashExpansion();

    // Listen for turbo:load in case hash changes on navigation
    this.turboLoadHandler = () => this.checkForHashExpansion();
    document.addEventListener('turbo:load', this.turboLoadHandler);
  }

  disconnect() {
    // Clean up event listener
    if (this.turboLoadHandler) {
      document.removeEventListener('turbo:load', this.turboLoadHandler);
    }
  }
  
  checkForHashExpansion() {
    // Check if current URL hash matches this accordion's ID
    const hash = window.location.hash.substring(1); // Remove #
    if (hash && this.element.id === hash) {
      // Delay expansion to ensure DOM is ready
      setTimeout(() => {
        this.expand();
        // Wait a bit more for the expansion animation to complete
        setTimeout(() => {
          // Scroll to the accordion header (title) for better positioning
          const header = this.element.querySelector('.accordion-header');
          if (header) {
            header.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start',
              inline: 'nearest'
            });
            // Add small offset to account for any fixed headers
            setTimeout(() => {
              window.scrollBy(0, -20);
            }, 300);
          }
        }, 200);
      }, 100);
    }
  }
  
  expand() {
    const item = this.element;
    const content = this.contentTarget;
    const icon = item.querySelector('.accordion-icon');
    
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
    if (icon) icon.style.transform = 'rotate(180deg)';
  }
  
  toggle() {
    const item = this.element;
    const content = this.contentTarget;
    const icon = item.querySelector('.accordion-icon');
    
    item.classList.toggle('active');
    
    if (item.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      if (icon) icon.style.transform = 'rotate(180deg)';
    } else {
      content.style.maxHeight = '0';
      if (icon) icon.style.transform = 'rotate(0)';
    }
  }
}
